import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ComponentFactoryResolver,
  Input,
  OnInit,
  ViewChild,
  ViewContainerRef
} from '@angular/core';
import { HomeAppointmentsComponent } from 'src/app/modules/pages/home-page/components/home-appointments/home-appointments.component';
import { HomeNewsletterComponent } from '../../../pages/home-page/components/home-newsletter/home-newsletter.component';

@Component({
  selector: 'cs-static',
  templateUrl: './cs-static.component.html',
  styleUrls: ['./cs-static.component.scss'],
})
export class CsStaticComponent implements OnInit, AfterViewInit {
  @Input() component;
  @Input() parent;

  @ViewChild('appointments', {
    read: ViewContainerRef,
  })
  appointments: ViewContainerRef;

  @ViewChild('newsletter', {
    read: ViewContainerRef,
  })
  newsletter: ViewContainerRef;

  constructor(
    private _factoryResolver: ComponentFactoryResolver,
    private _changeDetectorRef: ChangeDetectorRef
  ) { }

  ngAfterViewInit(): void {
    const appointmentFactory = this._factoryResolver.resolveComponentFactory(HomeAppointmentsComponent);
    if (this.appointments?.element) {
      this.appointments.clear();
      this.appointments.createComponent(
        appointmentFactory,
        null,
        this.appointments.injector
      );
    }

    const newsletterFactory = this._factoryResolver.resolveComponentFactory(HomeNewsletterComponent);
    if (this.newsletter?.element) {
      this.newsletter.clear();
      this.newsletter.createComponent(
        newsletterFactory,
        null,
        this.newsletter.injector
      );
    }

    this._changeDetectorRef.detectChanges();
  }

  ngOnInit(): void { }
}
